// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__LegalPage-module--D7xhe {
    max-width: 860px;
    margin: 0 auto;
    padding: var(--space-2xl) var(--space-md) var(--space-3xl);
}

/* The fragment is plain HTML shared with the legacy page, so it is styled by element rather than by class. */
.legal__LegalPage-module--iNTQN h1 {
    margin: 0 0 var(--space-lg);
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.05;
    text-wrap: balance;
}

.legal__LegalPage-module--iNTQN h3 {
    margin: var(--space-lg) 0 var(--space-xs);
    font-size: 21px;
    font-weight: 700;
}

.legal__LegalPage-module--iNTQN p,
.legal__LegalPage-module--iNTQN li {
    font-size: 17px;
    line-height: 1.65;
    color: var(--color-text-secondary);
}

.legal__LegalPage-module--iNTQN p {
    margin: 0 0 var(--space-sm);
}

/* Doubled class: vector's list reset (ul:not([class*="ant-"] ul)) outranks a single class. */
.legal__LegalPage-module--iNTQN.legal__LegalPage-module--iNTQN ul,
.legal__LegalPage-module--iNTQN.legal__LegalPage-module--iNTQN ol {
    margin: 0 0 var(--space-sm);
    padding-left: 1.5em;
}

.legal__LegalPage-module--iNTQN.legal__LegalPage-module--iNTQN ul {
    list-style: disc;
}

.legal__LegalPage-module--iNTQN.legal__LegalPage-module--iNTQN ol {
    list-style: decimal;
}

.legal__LegalPage-module--iNTQN li {
    margin-bottom: var(--space-2xs);
}

.legal__LegalPage-module--iNTQN a {
    /* The theme's link colour (hotmathsColors.primary800, 7.05:1 on the page background). */
    color: #874400;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/LegalPage.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,0DAA0D;AAC9D;;AAEA,6GAA6G;AAC7G;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,6FAA6F;AAC7F;;IAEI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wFAAwF;IACxF,cAAc;AAClB","sourcesContent":[".page {\n    max-width: 860px;\n    margin: 0 auto;\n    padding: var(--space-2xl) var(--space-md) var(--space-3xl);\n}\n\n/* The fragment is plain HTML shared with the legacy page, so it is styled by element rather than by class. */\n.legal :global(h1) {\n    margin: 0 0 var(--space-lg);\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1.05;\n    text-wrap: balance;\n}\n\n.legal :global(h3) {\n    margin: var(--space-lg) 0 var(--space-xs);\n    font-size: 21px;\n    font-weight: 700;\n}\n\n.legal :global(p),\n.legal :global(li) {\n    font-size: 17px;\n    line-height: 1.65;\n    color: var(--color-text-secondary);\n}\n\n.legal :global(p) {\n    margin: 0 0 var(--space-sm);\n}\n\n/* Doubled class: vector's list reset (ul:not([class*=\"ant-\"] ul)) outranks a single class. */\n.legal.legal :global(ul),\n.legal.legal :global(ol) {\n    margin: 0 0 var(--space-sm);\n    padding-left: 1.5em;\n}\n\n.legal.legal :global(ul) {\n    list-style: disc;\n}\n\n.legal.legal :global(ol) {\n    list-style: decimal;\n}\n\n.legal :global(li) {\n    margin-bottom: var(--space-2xs);\n}\n\n.legal :global(a) {\n    /* The theme's link colour (hotmathsColors.primary800, 7.05:1 on the page background). */\n    color: #874400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__LegalPage-module--D7xhe`,
	"legal": `legal__LegalPage-module--iNTQN`
};
export default ___CSS_LOADER_EXPORT___;
